import { apiServerFetchInvite } from '#/api/invite/apiFetchInvite';
import { RouteModule } from '#/horizon/components/RouteModule';
import { setSurrogate } from '#/horizon/middlewares/surrogate.middleware';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authSignupPath } from '#/modules/auth/routing/auth.paths';
import type { RoutePathLoaderArgs } from '#/routing/classes/types/RoutePathLoaderArgs';
import type { RouteProps } from '#/routing/types/RouteProps';

import { AuthSignupPage } from './AuthSignup.page';

export async function loader({
  request,
  url,
  context,
}: RoutePathLoaderArgs<typeof authSignupPath>) {
  const { invite: inviteId } = authSignupPath.searchParamsFromUrl(url);

  if (!inviteId) setSurrogate({ context, data: { type: 'hardcoded-route' } });

  const [inviteData] = await Promise.all([
    inviteId
      ? apiServerFetchInvite({ request, context })(inviteId)
      : Promise.resolve(null),
    AuthSignupPage as unknown as Promise<unknown>,
  ]);

  return { invite: inviteData ? inviteData.invite : null };
}

export default function AuthSignupRoute({
  loaderData: { invite },
}: RouteProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Sign Up')}>
      <AuthSignupPage invite={invite} />
    </RouteModule>
  );
}
